import types from '../../actions/types'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_VIEW_COMPANY_DIALOG:
      return true
    case types.SHOW_VIEW_COMPANY_DIALOG_FOR_CONTACT:
      return true
    case types.HIDE_VIEW_COMPANY_DIALOG:
      return false
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_ATTEMPT:
      return true
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_SUCCESS:
      return false
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_FAILURE:
      return false
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_ATTEMPT:
      return true
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_SUCCESS:
      return false
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_FAILURE:
      return false
    default:
      return state
  }
}

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_VIEW_COMPANY_DIALOG:
      return true
    case types.SHOW_VIEW_COMPANY_DIALOG_FOR_CONTACT:
      return true
    case types.HIDE_VIEW_COMPANY_DIALOG:
      return false
    default:
      return state
  }
}

export const selectedTab = (state = 'activities', action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_CHANGE_TAB:
      return action.tab
    case types.HIDE_VIEW_COMPANY_DIALOG:
      return 'activities'
    default:
      return state
  }
}

export const company = (state = null, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_SUCCESS:
      return action.data
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_SUCCESS:
      return action.data.company
    case types.HIDE_VIEW_COMPANY_DIALOG:
      return null
    case types.CONTACTS_COMPANY_EDIT_SUCCESS:
      return state === null
          ? state
          : action.data
    case types.CONTACTS_CONTACT_EDIT_SUCCESS:
      const updatedContact = action.data
      if (state === null) {
        return state
      } else {
        const companyContacts = state.contacts
            .slice()
            .map(contact => {
              return contact.id === updatedContact.id
                  ? updatedContact
                  : contact
            })

        return {
          ...state,
          contacts: companyContacts,
        }
      }
    default:
      return state
  }
}

export const contact = (state = null, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_SUCCESS:
      return action.data
    case types.HIDE_VIEW_COMPANY_DIALOG:
      return null
    case types.CONTACTS_CONTACT_EDIT_SUCCESS:
      const updatedContact = action.data
      return state === null
          ? state
          : updatedContact
    default:
      return state
  }
}

export const showCompletedActivities = (state = false, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_ACTIVITIES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('showCompleted'))
          ? action.filters.showCompleted
          : state
    default:
      return state
  }
}

export const showRejectedActivities = (state = false, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_ACTIVITIES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('showRejected'))
          ? action.filters.showRejected
          : state
    default:
      return state
  }
}

const folders = (state = [], action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_ATTEMPT:
      return []
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_ATTEMPT:
      return []
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_ADD_FOLDER:
      return [
        ...state,
        action.folder,
      ]
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return [action.folder]
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX:
      return state.slice(0, action.index)
    default:
      return state
  }
}

const rootFolder = (state = null, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_ATTEMPT:
      return null
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_ATTEMPT:
      return null
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return action.folder
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS:
      return state === null
          ? action.folder
          : state
    default:
      return state
  }
}

const currentFolder = (state = null, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_ATTEMPT:
      return null
    case types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_ATTEMPT:
      return null
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY:
      return action.folder
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS:
      return action.folder
    case types.VIEW_COMPANY_DIALOG_DOCUMENTS_ADD_FOLDER:
      return action.folder
    default:
      return state
  }
}

export const showAllQuotingRevisions = (state = false, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_QUOTES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('showAllRevisions'))
          ? action.filters.showAllRevisions
          : state
    default:
      return state
  }
}

export const showPostedInvoices = (state = false, action) => {
  switch (action.type) {
    case types.VIEW_COMPANY_DIALOG_INVOICES_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('showPosted'))
          ? action.filters.showPosted
          : state
    default:
      return state
  }
}

export const viewCompanyActivitiesPivotTableKey = 'dialogs.viewCompany.activities'
export const viewCompanyDocumentsPivotTableKey = 'dialogs.viewCompany.documents'
export const viewCompanyQuotesPivotTableKey = 'dialogs.viewCompany.quotes'
export const viewCompanyInvoicesPivotTableKey = 'dialogs.viewCompany.invoices'
export const viewCompanyOpportunitiesPivotTableKey = 'dialogs.viewCompany.opportunities'
export const viewCompanyContactsPivotTableKey = 'dialogs.viewCompany.contacts'

export default combineReducers({
  isLoading,
  isVisible,
  selectedTab,
  company,
  contact,
  showCompletedActivities,
  showRejectedActivities,
  folders,
  rootFolder,
  currentFolder,
  showAllQuotingRevisions,
  showPostedInvoices,
  activities: createPivotTableReducer({key: viewCompanyActivitiesPivotTableKey, defaultSortColumn: 'startDate'}),
  documents: createPivotTableReducer({key: viewCompanyDocumentsPivotTableKey, defaultSortColumn: 'folderName'}),
  quotes: createPivotTableReducer({key: viewCompanyQuotesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
  invoices: createPivotTableReducer({key: viewCompanyInvoicesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
  opportunities: createPivotTableReducer({key: viewCompanyOpportunitiesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
  contacts: createPivotTableReducer({key: viewCompanyContactsPivotTableKey, defaultSortColumn: 'forename,surname', defaultSortDirection: 'asc'}),
})
